export const config = {
  env: process.env.REACT_APP_ENV,
  version: process.env.REACT_APP_VERSION,
  apiUrl: process.env.REACT_APP_API_URL,
  mapboxToken: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN!,
  sentryDsn: process.env.REACT_APP_SENTRY_DSN,
  isSentinelImageryOn: process.env.REACT_APP_SENTINEL_IMAGERY_ON === 'true',
}
